/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import CrossIcon from '@atlaskit/icon/core/cross';
import { Pressable } from '@atlaskit/primitives/compiled/pressable';
import { token } from '@atlaskit/tokens';

import { messages } from '../messages';

const styles = cssMap({
	closeButton: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		paddingBlock: token('space.050'),
		paddingInline: token('space.050'),
		border: 'none',
		borderRadius: token('radius.medium'),
		cursor: 'pointer',
		backgroundColor: token('color.background.neutral.subtle'),
		'&:hover': {
			backgroundColor: token('color.background.neutral.subtle.hovered'),
		},
		'&:active': {
			backgroundColor: token('color.background.neutral.subtle.pressed'),
			transition: token('motion.button.pressed'),
		},
		transition: token('motion.button.hovered'),
	},
});

type CloseButtonProps = {
	onClick: () => void;
	testId?: string;
};

export const CloseButton = ({
	onClick,
	testId = 'close-button',
}: CloseButtonProps): JSX.Element => {
	const { formatMessage } = useIntl();
	const label = formatMessage(messages.closeChatAriaLabel);

	return (
		<Pressable onClick={onClick} aria-label={label} xcss={styles.closeButton} testId={testId}>
			<CrossIcon label={label} color={token('color.icon')} testId={`${testId}-icon`} />
		</Pressable>
	);
};
